export const SEOUL_REGION_CODE = '11';
export const DEFAULT_NEIGHBORHOOD_CATEGORY_KEYWORD = '소아과';
